<template>
  <List v-if="viewType === 'list'" />
  <Create v-else-if="viewType === 'new'" />
</template>

<script setup>
import { watch, ref } from "vue";
import { useRoute } from "vue-router";
import List from "./Projects/List.vue";
import Create from "./Projects/Create.vue";

const route = useRoute();

const viewType = ref("");
watch(
  () => route.query?.action,
  /**
   * @param {string?} action
   */
  (action) => {
    if (action === undefined) {
      viewType.value = "list";
    } else {
      viewType.value = action;
    }
  },
  { immediate: true }
);
</script>
